import axios from 'axios'
import config from './config'

/**
 * 上传文件类型
 * @param url 
 * @param formData
 */

const __axios = axios.create()

export const axiosFormData = (url: string, formData) => {
    return new Promise((resolve, reject) => {
        __axios({
            method: 'post',
            url,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }).then(data => {
            if (data.data.code === 200) {
                resolve(data.data)
            } else {
                reject(data.data)
            }
            if (config.env === 'dev') {
                console.log(data.data)
            }
        }).catch(data => {
            if (config.env === 'dev') {
                console.log(data.data)
            }
            reject(data)
        })
    })
}

export default axiosFormData